import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { filtersMessages } from './messages';

import Radio from 'components/forms/Radio';

export const GRAPH_TYPES = {
    ROOMS: 'rooms',
    REVENUE: 'revenue',
};

const Container = styled.div`
    padding: 20px;
`;

const DataTypeFilters = ({ dataType, onChangeDataType }) => {
    const onChangeFilter = (event) => {
        onChangeDataType(event.target.value);
    };

    return (
        <Container>
            <Radio.Group onChange={onChangeFilter} value={dataType} style={{ marginBottom: 8 }} name="datatype_filter">
                <Radio.Button value={GRAPH_TYPES.ROOMS}>
                    <FormattedMessage {...filtersMessages.roomsLabel} />
                </Radio.Button>
                <Radio.Button value={GRAPH_TYPES.REVENUE}>
                    <FormattedMessage {...filtersMessages.revenueLabel} />
                </Radio.Button>
            </Radio.Group>
        </Container>
    );
};

export default DataTypeFilters;
